import { render, staticRenderFns } from "./BsiForm18Resolution.vue?vue&type=template&id=f5788032&scoped=true&"
import script from "./BsiForm18Resolution.vue?vue&type=script&lang=js&"
export * from "./BsiForm18Resolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5788032",
  null
  
)

export default component.exports